/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Resend_TitleInputs */

const en_admin_settings_groups_resend_title = /** @type {(inputs: Admin_Settings_Groups_Resend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend`)
};

/**
* | output |
* | --- |
* | "Resend" |
*
* @param {Admin_Settings_Groups_Resend_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_resend_title = /** @type {((inputs?: Admin_Settings_Groups_Resend_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Resend_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_resend_title(inputs)
});
export { admin_settings_groups_resend_title as "admin.settings.groups.resend.title" }